import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsInstacartComponent } from './simple-icons-instacart.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsInstacartComponent ],
    exports:      [ SimpleIconsInstacartComponent ],
    bootstrap:    []
})
export class SimpleIconsInstacartModule {}
